function findUsedSubjectAttributesInPolicy(nodes) {

    // const usedSubjectAttributeSet = new Set(
    //     nodes
    //         // .filter(node => (node.type === 'subject'))
    //         .flatMap(extractUsedAttributesFromNode)
    //         .map(attr => `${attr.name}::${attr.attributeType}`)
    // )

    // const usedSubjectAttributeArray = Array.from(usedSubjectAttributeSet).map(attrString => {
    //     const [name, attributeType] = attrString.split('::');
    //     return { name, attributeType };
    // });

    // console.log("usedSubjectAttributeSet:", usedSubjectAttributeSet);
    // console.log("usedSubjectAttributeArray:", usedSubjectAttributeArray);

    const attributeMap = {};

    nodes
        .flatMap(extractUsedAttributesFromNode)
        .forEach(attr => {
            const key = `${attr.name}::${attr.attributeType}`;
            if (!attributeMap[key]) {
                attributeMap[key] = {
                    name: attr.name,
                    attributeType: attr.attributeType,
                    count: 0
                };
            }
            attributeMap[key].count += 1;
        });

    const usedSubjectAttributes = attributeMap;

    return usedSubjectAttributes;
}

function extractUsedAttributesFromNode(node) {
    if (
        node.data?.general_properties?.subjectConstraints
    ) {
        return node.data.general_properties.subjectConstraints.flatMap(constraint =>
            (constraint.child || []).map(child => ({
                name: child?.l_operand?.name,
                attributeType: child?.l_operand?.attributeType
            }))
        ).filter(attr => attr.name && attr.attributeType)
    }

    // case อื่นๆ
    return []
}

export default findUsedSubjectAttributesInPolicy